import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import ClientExplorer from '@frontend/ui/views/client-explorer/ClientExplorer.vue';
import ClientGroupsView from '@frontend/ui/views/client-groups/ClientGroupsView.vue';
import CreateClientGroupView from '@frontend/ui/views/client-groups/CreateClientGroupView.vue';
import ErrorTestView from '@frontend/ui/views/ErrorTestView.vue';
import FeatureAccessDenied from '@frontend/ui/views/FeatureAccessDenied.vue';
import StakeUI from '@frontend/ui/views/StakeUI.vue';
import CompanyScreenerView from '@frontend/ui/views/values/CompanyScreenerView.vue';
import FundScreenerView from '@frontend/ui/views/values/FundScreenerView.vue';
import FundSymbolView from '@frontend/ui/views/values/FundSymbolView.vue';
import ValuesEditor from '@frontend/ui/views/values/ValuesEditor.vue';
import PortfolioDesignerView from '@frontend/ui/views/values/PortfolioDesignerView.vue';
import ReportsView from '@frontend/ui/views/values/ReportsView.vue';
import ClientPreferenceResultsView from '@frontend/ui/views/wizard/ClientPreferenceResultsView.vue';
import VisitorWizardView from '@frontend/ui/views/wizard/VisitorWizardView.vue';
import DevelopmentView from '../views/DevelopmentView.vue';
import DefaultView from '../views/DefaultView.vue';
import HomeView from '../views/HomeView.vue';
import ToolsView from '../views/ToolsView.vue';
import SetupView from '../views/SetupView.vue';
import AskAnythingView from '@frontend/ui/features/ask-anything/views/AskAnythingView.vue';
import PeopleView from '../views/people/PeopleView.vue';
import LegacyProspectsView from '../views/people/LegacyProspectsView.vue';
import LegacyClientsView from '../views/people/LegacyClientsView.vue';
import LegacyOrgsView from '../views/people/LegacyOrgsView.vue';
import PortfolioList from '../views/portfolio/PortfolioList.vue';
import ConfigurePortfolios from '../views/portfolio/ConfigurePortfolios.vue';
import PortfolioAlert from '../views/portfolio/PortfolioAlert.vue';
import InstitutionalQnrIntroView from '../views/questionnaire/InstitutionalQnrIntroView.vue';
import InstitutionalQnrResultsIPS from '../views/questionnaire/InstitutionalQnrResultsIPS.vue';
import InstitutionalQnrResultsSectionView from '../views/questionnaire/InstitutionalQnrResultsSectionView.vue';
import InstitutionalQnrResultsView from '../views/questionnaire/InstitutionalQnrResultsView.vue';
import InstitutionalQnrSectionView from '../views/questionnaire/InstitutionalQnrSectionView.vue';
import InstitutionalQnrThanksView from '../views/questionnaire/InstitutionalQnrThanksView.vue';
import InstitutionalQnrView from '../views/questionnaire/InstitutionalQnrView.vue';
import PersonalBehavioralQnrIntroView from '../views/questionnaire/PersonalBehavioralQnrIntroView.vue';
import PublicBehavioralQnrIntroView from '../views/questionnaire/PublicBehavioralQnrIntroView.vue';
import RiskQnrResultsView from '../views/questionnaire/RiskQnrResultsView.vue';
import MercerSimilarTickerSearch from '@frontend/ui/features/example/views/MercerSimilarTickerSearch.vue';
import CrmMappingView from '../views/advisor/CrmMapping.vue';
import JobsView from '@frontend/ui/features/ai-jobs/views/JobsView.vue';
import JobNewView from '@frontend/ui/features/ai-jobs/views/JobNewView.vue';
import JobSingleView from '@frontend/ui/features/ai-jobs/views/JobSingleView.vue';

import aiRouter from '@frontend/ui/ai/router/index.js';
import chatRoutes from '@frontend/ui/features/chat/routes.js';
import clientPortalRoutes from '@frontend/ui/features/client-portal/routes.js';
import homepageRoutes from '@frontend/ui/features/homepage/routes.js';
import teamsRoutes from '@frontend/ui/features/teams/routes.js';
import meetingRoutes from '@frontend/ui/features/meetings/routes.js';
import taskRoutes from '@frontend/ui/features/tasks/routes.js';
import oauthRoutes from '@frontend/ui/features/oauth/routes.js';
import portfolioCheckupRoutes from '../features/checkup/routes.js';
import embedRoutes from '../features/embeds/routes.js';
import exampleFeature from '../features/example/routes.js';
import piniaRoutes from '../features/pinia/routes.js';

const routes = [
  {
    // A place to view and test components in development
    // Should only be accessible by internal users
    name: 'Development',
    path: '/advisor/development',
    component: DevelopmentView,
  },
  {
    name: 'Default',
    path: '/advisor',
    component: DefaultView,
    children: [
      {
        path: '/',
        redirect: 'home',
      },
      {
        name: 'ai-job-new',
        path: 'ai-jobs/new',
        component: JobNewView,
        props: true,
      },
      {
        name: 'ai-job-single',
        path: 'ai-jobs/:jobId',
        component: JobSingleView,
        props: true,
      },
      {
        name: 'ai-jobs',
        path: 'ai-jobs',
        component: JobsView,
      },
      {
        name: 'home',
        path: 'home',
        component: HomeView,
      },
      {
        name: 'tools',
        path: 'tools',
        component: ToolsView,
        children: [
          {
            path: 'mercer-similar-ticker-search',
            component: MercerSimilarTickerSearch,
            name: 'mercer-similar-ticker-search',
          },
        ],
      },
      {
        name: 'setup',
        path: 'setup',
        component: SetupView,
      },
      {
        name: 'ask-anything',
        path: 'ask-anything/:conversationId?',
        component: AskAnythingView,
      },
      // Legacy views
      {
        name: 'prospects',
        path: 'prospects',
        component: LegacyProspectsView,
      },
      {
        name: 'clients',
        path: 'clients',
        component: LegacyClientsView,
      },
      {
        name: 'organizations',
        path: 'organizations',
        component: LegacyOrgsView,
      },
      // New views
      {
        name: 'prospects',
        path: 'people',
        component: PeopleView,
      },
      {
        name: 'people',
        path: 'people',
        component: PeopleView,
      },
      {
        name: 'portfolios',
        path: 'portfolios',
        component: PortfolioList,
      },
      {
        name: 'configure-portfolios',
        path: 'configure-portfolios',
        component: ConfigurePortfolios,
      },
      {
        name: 'portfolio-alert',
        path: 'portfolio-alert',
        component: PortfolioAlert,
      },
      // ValuesCore Pages
      {
        name: 'reports',
        path: 'reports',
        component: ReportsView,
      },
      {
        name: 'fund-screener',
        path: 'fund-screener',
        component: FundScreenerView,
        children: [
          {
            path: ':symbol',
            component: FundSymbolView,
            name: 'detail',
            props: true,
          },
        ],
      },
      {
        name: 'values-editor',
        path: 'values-editor',
        component: ValuesEditor,
      },
      {
        name: 'portfolio-designer',
        path: 'portfolio-designer',
        component: PortfolioDesignerView,
      },
      {
        name: 'company-screener',
        path: 'company-screener',
        component: CompanyScreenerView,
      },
      {
        name: 'crm-mapping',
        path: 'crm-mapping',
        component: CrmMappingView,
      },
      ...homepageRoutes,
      ...teamsRoutes,
      ...portfolioCheckupRoutes,
      ...meetingRoutes,
      ...taskRoutes,
      ...exampleFeature,
      ...oauthRoutes,
    ],
  },
  {
    name: 'ErrorTest',
    path: '/advisor/test/errors',
    component: ErrorTestView,
  },
  {
    name: 'dont-have-feature',
    path: '/advisor/dont-have-feature',
    component: FeatureAccessDenied,
  },
  {
    name: 'institutional-qnr',
    path: '/visitor/institutional-questionnaire',
    component: InstitutionalQnrView,
    children: [
      {
        name: 'institutional-qnr-intro',
        path: 'intro',
        component: InstitutionalQnrIntroView,
      },
      {
        name: 'public-behavioral-qnr-intro',
        path: 'publicbehavioralintro',
        component: PublicBehavioralQnrIntroView,
      },
      {
        name: 'personal-behavioral-qnr-intro',
        path: 'personalbehavioralintro',
        component: PersonalBehavioralQnrIntroView,
      },
      {
        name: 'institutional-qnr-section',
        path: 'sections/:section',
        component: InstitutionalQnrSectionView,
      },
      {
        name: 'institutional-qnr-thanks',
        path: 'thanks',
        component: InstitutionalQnrThanksView,
      },
    ],
  },
  {
    name: 'institutional-qnr-results',
    path: '/advisor/institutional-qnr-results',
    component: InstitutionalQnrResultsView,
    children: [
      {
        name: 'institutional-qnr-results-section',
        path: 'sections/:section',
        component: InstitutionalQnrResultsSectionView,
      },
      {
        name: 'institutional-qnr-results-ips',
        path: 'ips',
        component: InstitutionalQnrResultsIPS,
      },
    ],
  },
  {
    name: 'client-groups',
    path: '/advisor/client-groups',
    component: ClientGroupsView,
  },
  {
    name: 'create-client-group',
    path: '/advisor/create-client-group',
    component: CreateClientGroupView,
  },
  {
    name: 'risk-qnr-results',
    path: '/advisor/risk/results/:prospectId',
    component: RiskQnrResultsView,
  },
  {
    name: 'risk-qnr-results-visitor',
    path: '/visitor/risk/results/:prospectId',
    component: RiskQnrResultsView,
  },
  {
    name: 'wizard',
    path: '/visitor/wizard',
    component: VisitorWizardView,
  },
  {
    name: 'wizard-results',
    path: '/advisor/wizard/results',
    component: ClientPreferenceResultsView,
  },
  {
    name: 'edit-client-group',
    path: '/advisor/edit-client-group/:id',
    component: CreateClientGroupView,
  },
  {
    name: 'client-explorer',
    path: '/advisor/client-explorer',
    component: ClientExplorer,
  },
  {
    name: 'stake-ui',
    path: '/advisor/stakeui',
    component: StakeUI,
  },
  ...piniaRoutes,
  ...embedRoutes,
  ...aiRouter.getRoutes(),
  ...chatRoutes,
  ...clientPortalRoutes,
];

const router = new VueRouter({
  routes: routes,
  mode: 'history',
  base: 'ui/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// This code keeps the query params from the previous route (advisor and vuid)
router.beforeEach((to, from, next) => {
  // only run on any of your institutional-qnr routes
  const isQnrRoute = r => r.name && r.name.startsWith('institutional-qnr');

  if (
    isQnrRoute(from) &&
    isQnrRoute(to) &&
    Object.keys(from.query).length > 0 &&
    Object.keys(to.query).length === 0
  ) {
    return next({
      ...to,
      query: { ...from.query },
    });
  }

  next();
});

export default router;
